<template>
  <div class="im-message" :class="[{grey: !isMine}]">
    <div class="im-message__header">
      <div class="im-message__username">{{ username }}</div>
      <div class="im-message__info">
        <div v-if="isMine" class="im-message__status">{{ statusText }}</div>
        <div class="im-message__date">{{ date }}</div>
      </div>
    </div>
    <div class="im-message__content" v-if="promoId">
      <i>Рекомендация:</i>
      <span v-if="promoMessagesCount" title="Всего разослано сообщений / Это сообщение получило пользователей"  v-text="promoMessagesCount + '/' + promoUsersCount"></span>
    </div>
    <div class="im-message__content" v-html="content"></div>
    <div class="im-message__content" v-if="promoCanShare">
      <i>Если вы согласны распространить рекомендацию дальше по списку друзей нажмите "распространить дальше"</i><br/>
      <button class="im-message__promo-share-btn" @click="promoShare">распространить дальше</button>
    </div>
  </div>
</template>

<script>
  import ADL from "../../../../ADL";

  const adl = new ADL();

  export default {
    name: 'Message',
    props: {
      isMine: {
        type: Boolean,
        default: false
      },
      isForGroup: {
        type: Boolean,
        default: false
      },
      username: {
        type: String,
        default: ''
      },
      statusText: {
        type: String,
        default: ''
      },
      timestamp: {
        type: Number,
        default: '0'
      },
      content: {
        type: String,
        default: ''
      },
      promoId: {
        type: Number,
        default: 0
      },
      promoMessagesCount: {
        type: Number,
        default: 0
      },
      promoUsersCount: {
        type: Number,
        default: 0
      },
      promoCanShare: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      date(){
        return this.timeConverter(this.timestamp);
      }
    },
    methods: {
      timeConverter(UNIX_timestamp){
        const a = new Date(UNIX_timestamp * 1000);
        const months = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
        const year = a.getFullYear();
        const month = months[a.getMonth()];
        const date = a.getDate();
        const hour = a.getHours();
        const min = (() => { const min = a.getMinutes(); return min > 9 ? min : '0' + min; })();
        const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
        return time;
      },
      async promoShare() {
        const params = {
          url: '/ajax.php?c=classPromo&m=Promo&pdo=share&Update=1&Code=' + this.promoId,
          method: 'get',
        };
        try {
          const response = await adl.oldAjaxHack(params);
          if (response.data.Errors.length) {
            alert(response.data.Errors.join('. '))
          } else {
            this.promoCanShare = false;
            alert("Разослано.");
          }
        } catch (e) {
          console && console.error('e', e);
          alert('Ошибка. Попробуйте позже');
        }
      }
    }
  };
</script>

<style lang="scss">
  .im-message {
    border-bottom: 1px solid #D6D6D6;
    margin: 0;
    padding: 10px;

    &__header {
      display: flex;
      justify-content: space-between;
      margin: 0;
    }
    &__content {
      word-break: break-word;
    }

    &__username {
      color: #1588E2;
    }

    &__info {
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      font-size: 10px;
    }

    &__status {
      margin: 0 10px 0 0;
      color: #4c8aad;
    }

    &__group-label {
      margin: 0 10px 0 0;
      color: #5a5a5a;
    }

    &__date {
      font-size: 10px;
    }

    &.grey{
      background: #F5F5F5;
    }

    &__promo-share-btn {
      background: #1588E2;
      border: none;
      color: #ffffff;
      font-size: 12px;
      padding: 3px 9px;
      margin-top: 5px;
    }
  }
</style>